module.exports = __webpack_public_path__ + "static/media/6.04de0c11.jpg";